import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 期貨交易知識認知確認表
 */
const ConfirmationPostBack = [
    'POST',
    RouteUrlList.API_ConfirmationPostBack.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: '',
        errorCode: ''
    }
];
export default ConfirmationPostBack;
